module.exports = "<hybse-admin-adduser [actionType]=\"'edit'\" [userType]=\"'Admin'\">\n\n</hybse-admin-adduser>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/admin/edituser/edituser.component.html
// module id = ../../../../../src/app/components/pages/users/admin/edituser/edituser.component.html
// module chunks = main